/* eslint-disable simple-import-sort/imports */
import React from 'react'
import { createComponentWrapperWithRef, styled } from '../../theme'

import { COLORS } from '../../theme/colors'
import { MsdkComponent } from '../../utils'
import { ButtonAlignProps } from './ButtonAlignProps'
import { ButtonBase } from './ButtonBase'
/* eslint-enable simple-import-sort/imports */

const StyledMuiButton = styled(ButtonBase, { shouldForwardProp: (prop) => prop !== '$alignLeft' })<{
  $alignLeft?: boolean
}>`
  background-color: ${COLORS.error.main};
  border-radius: 20px;
  box-shadow: unset;
  padding: 8px 24px;
  height: 40px;
  font-size: 0.938rem;
  font-weight: 700;
  line-height: 160%;
  text-transform: unset;
  ${({ $alignLeft }) => ($alignLeft ? 'margin-right: auto;' : '')}

  &:hover {
    background-color: ${COLORS.error.dark};
    box-shadow: unset;
  }

  &:disabled {
    background-color: ${COLORS.action.diasbeldBackround};
    color: ${COLORS.action.disabled};
    box-shadow: unset;
  }
`

const StyledNovaButton = styled(ButtonBase, { shouldForwardProp: (prop) => prop !== '$alignLeft' })<{
  $alignLeft?: boolean
}>`
  ${({ $alignLeft }) => ($alignLeft ? 'margin-right: auto;' : '')}
`

const StyledButtonAlternative = createComponentWrapperWithRef(
  {
    mui: StyledMuiButton,
    nova: StyledNovaButton,
    novaProps: {
      color: 'error',
    },
  },
  'StyledButtonAlternative',
)

// eslint-disable-next-line import/no-unused-modules
export function ButtonAlternative({ alignLeft, ...props }: ButtonAlignProps): MsdkComponent {
  return (
    <StyledButtonAlternative $alignLeft={alignLeft} variant="contained" {...props}>
      {props.children}
    </StyledButtonAlternative>
  )
}
